import { useUser } from "@/components/hooks/useUser";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";



export default function SignInOut() {

    const { data: user } = useUser()
    const signIn = () => {
        console.log("Sign In");
        window.location.href = process.env.REACT_APP_SIGNIN_URL?.toString() || "";

    }

    const signOut = () => {
        console.log("Sign Out");
        window.location.href = process.env.REACT_APP_SIGNOUT_URL?.toString() || "";
    }

    return (<div className="flex"> {
        user?.result.id ? (<TooltipProvider>
            <Tooltip>
                <TooltipTrigger onClick={signOut}>                    
                    <span className="text-base lg:text-xs xl:text-xs 2xl:text-sm bg-transparent hover:bg-transparent focus:bg-transparent data-[state=open]:bg-transparent data-[active]:bg-transparent">
                        SIGN OUT
                    </span>
                </TooltipTrigger>
            </Tooltip>
        </TooltipProvider>) : (<TooltipProvider>
            <Tooltip>
                <TooltipTrigger onClick={signIn}>                    
                    <span className="text-base lg:text-xs xl:text-xs 2xl:text-sm bg-transparent hover:bg-transparent focus:bg-transparent data-[state=open]:bg-transparent data-[active]:bg-transparent">
                        SIGN IN
                    </span>
                </TooltipTrigger>
                <TooltipContent className="max-w-xs p-3 bg-black/90 text-white rounded-md shadow-lg text-xs font-medium normal-case">
                    <span className="block mb-1 text-harvey-red font-bold normal-case">Sign In Required</span>
                    <span className="block normal-case">You must be onboarded to sign in.<br />If you need access, please contact support.</span>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>)
    } </div>);
}
